<template>
  <div>
    <div class="wrapper-font">
      <div class="left-side">
        <aha-input
          v-model="searchQuery"
          :placeholder="$i18nPresenter.t('Search')"
        />

        <ul class="list-font-available">
          <p class="empty-list" v-if="filteredItems.length === 0">
            {{ $i18nPresenter.t('No fonts found') }}
          </p>
          <li v-for="item in filteredItems" :key="item.id">
            <input
              type="checkbox"
              :id="item.id"
              v-model="selectedItems"
              :value="item"
              @change="onChangeCheck(item)"
            >
            <label :for="item.id">
              <node-content :family="item.family" />
            </label>
          </li>
        </ul>
      </div>
      <div class="right-side">
        <p class="font-bold title-font">
          <b>{{ $i18nPresenter.t('My fonts:') }}</b>
        </p>
        <ul class="list-font-selected" ref="selected-list">
          <li v-for="item in reverseSelectedItems" :key="item.id">
            <node-content v :family="item.family" />
            <aha-icon
              class="remove-icon"
              height="16"
              width="16"
              name="close"
              viewBox="0 0 24 24"
              @click="removeItem(item)"
            />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import googleFontv2 from '@/components-v2/font/GoogleFonts'
import Util from '@/util'
import eventCategories from '@/constant/eventCategories'

const { PRESENTATION_EDITOR } = eventCategories
export default {
  name: 'FontManagerV2',
  components: {
    nodeContent: {
      props: {
        family: {
          type: String,
          required: true,
        },
      },
      render() {
        return (
            // eslint-disable-next-line global-require,import/no-dynamic-require
            <img style="height:40px" src={require(`@/assets/images/font/${this.family}.png`)} loading="lazy" />
        )
      },
    },
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    selected: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      googleFontv2,
      availableItems: [

      ],
      selectedItems: [],
      searchQuery: '',
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    reverseSelectedItems() {
      return this.selectedItems.slice().reverse()
    },
    filteredItems() {
      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase()
        return this.availableItems.filter((item) => {
          return item.family.toLowerCase().includes(query)
        })
      }
      return this.availableItems
    },

    filteredFromData() {
      return googleFontv2.filter((fontGoogle) => {
        return this.selected.find((fontSelected) => {
          return fontSelected.family !== fontGoogle.family
        })
      })
    },
  },
  watch: {
    selectedItems: {
      handler(val) {
        this.$emit('change', val)
      },
      deep: true,
    },
  },
  created() {
    this.loadFontLeft()
  },

  methods: {
    onChangeCheck(item) {
      if (this.selectedItems.family !== item.family) {
        Util.mixpanelTracking(PRESENTATION_EDITOR, 'Design > Font library > Select font', null, null, {
          font: item.family,
          plan: this.currentUser.plan,
        })
      }
    },
    loadFontLeft() {
      // Load the data for the current page
      this.availableItems = this.filteredFromData.map((font, key) => ({
        id: key + 1,
        family: font.family,
        category: font.category,
      }))
      this.selectedItems = this.availableItems.filter((item) => {
        return this.selected.find((fontSelected) => {
          return fontSelected.family === item.family
        })
      })
    },
    removeItem(item) {
      const index = this.selectedItems.indexOf(item)
      if (index !== -1) {
        this.selectedItems.splice(index, 1)
      }
      Util.mixpanelTracking(PRESENTATION_EDITOR, 'Design > Font library > My font > Delete font', null, null, {
        font: item.family,
        plan: this.currentUser.plan,
      })
    },
  },
}
</script>
<style lang="scss" scoped >

.wrapper-font {
  display: flex;
  height: 500px;
}
.left-side {
  flex: 3;
  margin-right: 12px;
  height: 100%;

  li {
    display: flex;
    align-items: center;
    padding-left: 12px;
  }

}
.empty-list{
  text-align: center;
  margin: 10px;
}

.right-side {
  flex: 1;
  height: 99%;
  border: 1px solid #e5e5e5;

  scrollbar-width: none; /* for Firefox */
  box-sizing: content-box; /* So the width will be 100% + 17px */
  border-radius:4px;
  li {
    cursor: pointer;
    justify-content: space-between;
  }
  &::-webkit-scrollbar {
    display: none;
  }
  img {
    height: 35px;
    margin-left : 12px;
  }
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  border-bottom: 1px solid #e5e5e5;

}

label {
  margin-left: 12px;
}

.list-font-selected{
  overflow-y : auto;
  height: 90%;
  li{
    .remove-icon {
      display: none;
      margin-right: 10px;
      path {
        fill: #AFAFAF;
      }
    }
  }
  li:hover {
    .remove-icon  {
      display: block;

    }
  }
}
.title-font{
  padding : 13px 0px 13px 12px;
  border-bottom: 1px solid #e5e5e5;
}
.list-font-available{

  overflow-y: auto;
  -ms-overflow-style: auto;
  margin-top: 12px;
  label {
    width : 100%;
    cursor: pointer;
  }
  border: 1px solid #e5e5e5;
  border-radius :4px;
  height: 445px;
  li {
    cursor: pointer;
    display: flex;
  }
}
.right-side{

  li {
    display : flex;
    align-items : center;
    cursor: pointer;
    justify-content : space-between;
  }
}

</style>
